/**
 * Slide Workspace Route
 * Dedicated workspace for single slide preview and editing
 * Uses the unified VideoWorkspaceShell with mode='slide'
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { VideoWorkspaceShell } from '../../../components/video-workspace/VideoWorkspaceShell';
import { conversationAPI } from '../../../services/api';

export const Route = createFileRoute("/chat/$conversationId/slide-workspace")({
  component: SlideWorkspaceRoute,
  loader: async ({ params }) => {
    try {
      // Validate conversation exists and is a SLIDE type
      const { conversation } = await conversationAPI.getById(params.conversationId);

      // Redirect non-slide conversations to gallery
      if (conversation?.collectionType !== 'SLIDE') {
        throw redirect({
          to: '/chat/$conversationId/gallery',
          params: { conversationId: params.conversationId },
          search: { slide: undefined, tab: undefined }
        });
      }

      return { conversation };
    } catch (error) {
      // Re-throw redirect errors
      if (error && typeof error === 'object' && 'isRedirect' in error) {
        throw error;
      }
      console.error('Slide workspace route - Failed to load data:', error);
      throw redirect({
        to: '/chat/$conversationId',
        params: { conversationId: params.conversationId }
      });
    }
  }
});

function SlideWorkspaceRoute() {
  const { conversationId } = Route.useParams();

  return <VideoWorkspaceShell conversationId={conversationId} mode="slide" />;
}
